import { DeviceResponseType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IDeviceState, IDeviceStateData } from 'lavva.exalushome/build/js/Services/Devices/IDeviceState';

export const getChannelState = <T>(states: IDeviceState<IDeviceStateData>[], stateType: DeviceResponseType) => {
  return states.find((state) => state.TypeAsEnum === stateType) as T | undefined;
};
